function NotFound() {
  return (
    <div>
      <h1>404 - Not Found</h1>
      <p>La página que buscas no existe o está en construcción.</p>
    </div>
  );
}
export default NotFound;